var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 119,
    viewBox: "0 0 119 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 119,
    height: 119,
    rx: 59.5,
    fill: "#FFF5F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 76.916,
    width: 58,
    height: 4.83333,
    rx: 2.41667,
    fill: "#D91F05"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 57.584,
    width: 58,
    height: 4.83333,
    rx: 2.41667,
    fill: "#D91F05"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 38.25,
    width: 58,
    height: 4.83333,
    rx: 2.41667,
    fill: "#D91F05"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 38.25,
    y: 31,
    width: 4.83333,
    height: 19.3333,
    rx: 2.41667,
    fill: "#D91F05"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 74.5,
    y: 50.334,
    width: 4.83333,
    height: 19.3333,
    rx: 2.41667,
    fill: "#D91F05"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 69.666,
    width: 4.83333,
    height: 19.3333,
    rx: 2.41667,
    fill: "#D91F05"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.434d5a7d40429a8e79f5709e75501cca.svg";
export { ForwardRef as ReactComponent };